module.exports = __webpack_public_path__ + "img/user_type.86eb19e9.svg";